import Vue from "vue";
import Router from "vue-router";

import { store } from "../main.js";

import Home from "./home";
import Login from "./login";
import User from "./user";
import Role from "./role";
import Shift from "./shift";
import Team from "./team";
import Branch from "./branch";
import Profile from "./profile";
import ThemeCategory from "./theme_category";
import Theme from "./theme";
import Schedule from "./schedule";
import Event from "./event";
import AreasTurnos from "./areasturnos"
import Domains from "./domains"
import Admin from "./admin"
import DomainsLogin from "./domainsLogin.js"
import CheckUser from "./checkUser";
import Parameters from "./parameters";
import Reports from "./reports";
import GptLogs from "./gptLogs";
import TermsOfUse from "./terms_of_use";
import UserLogs from "./userlogs";
import CreateDelete from "./createdeletetenant.js";
import CheckList from "./checkList";
import Nonconformity from "./nonconformity";
import env from "../config/env.js";
import ChecklistCategory from "./checklist_category";
import NonconformityType from "./nonconformitytype";
import AbsenceReason from "./absence_reason";
Vue.use(Router);

const router = new Router({
    mode: "history",
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Role,
        Shift,
        Team,
        Branch,
        Profile,
        ThemeCategory,
        Theme,
        Schedule,
        Event,
        AreasTurnos,
        Domains,
        DomainsLogin,
        Admin,
        CheckUser,
        Parameters,
        Reports,
        GptLogs,
        TermsOfUse,
        UserLogs,
        CreateDelete,
        CheckList,
        Nonconformity,
        ChecklistCategory,
        NonconformityType,
        AbsenceReason
    ]
});

router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem("token");

    if (!authenticated && to.path.toString() != "/domains/login") {
        next('/domains/login');
    }

    next();

});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === "Home") {
        _name = "";
        _route = "";
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js